import React from "react";
import { Select, Form, Radio } from "antd";
import { Controller } from "react-hook-form";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledSelect from "../../components/Backoffice/ControlledSelect";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const AddAddressForm = ({
  control,
  options = {},
  watch,
  errors,
  check = false,
  setValue,
}) => {
  const { states = [], cities = [], countries = [] } = options;

  const getCountryOptions = () => {
    const opts = [];
    countries.forEach((country) => {
      opts.push(
        <Option key={country._id} value={country._id}>
          {country.name}
        </Option>
      );
    });
    return opts;
  };

  const getStateOptions = () => {
    const opts = [];

    states.forEach((state) => {
      opts.push(
        <Option key={state._id} value={state._id}>
          {state.name}
        </Option>
      );
    });

    return opts;
  };

  const getCityOptions = () => {
    let opts = [];

    cities.forEach((city) => {
      opts.push(
        <Option key={city._id} value={city._id}>
          {city.name}
        </Option>
      );
    });
    return opts;
  };

  return (
    <Form {...formItemLayout}>
      {check && (
        <Controller
          name="type"
          control={control}
          render={({ field }) => (
            <Form.Item
              label="Address Type"
              required
              labelAlign="left"
              validateStatus={errors.type ? "error" : "success"}
              help={errors?.type?.message}
            >
              <Radio.Group {...field}>
                <Radio value="pickupAddress">Pickup</Radio>
                <Radio value="billingAddress">Billing</Radio>
              </Radio.Group>
            </Form.Item>
          )}
        />
      )}
      <ControlledInput
        required
        control={control}
        name="addressLine1"
        label="AddressLine1"
        errors={errors}
      />
      <ControlledInput
        control={control}
        name="addressLine2"
        label="AddressLine2"
        errors={errors}
      />
      <ControlledSelect
        required
        control={control}
        name="country"
        label="Country"
        options={getCountryOptions()}
        errors={errors}
        customChange={() => {
          setValue("state", "");
          setValue("city", "");
        }}
      />
      <ControlledSelect
        required
        control={control}
        name="state"
        label="State"
        options={getStateOptions()}
        errors={errors}
        customChange={() => {
          setValue("city", "");
        }}
      />
      <ControlledSelect
        required
        control={control}
        name="city"
        label="City"
        options={getCityOptions()}
        errors={errors}
        customChange={() => {}}
      />
      <ControlledInput
        required
        control={control}
        name="pincode"
        label="Pincode"
        errors={errors}
      />
      {/*<Controller
        name="addressLine1"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="Address Line 1"
            required
            labelAlign="left"
            validateStatus={errors.addressLine1 ? "error" : "success"}
            help={errors?.addressLine1?.message}
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
      <Controller
        name="addressLine2"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="Address Line 2"
            labelAlign="left"
            validateStatus={errors.addressLine2 ? "error" : "success"}
            help={errors?.addressLine2?.message}
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
      <Controller
        name="country"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="Country"
            labelAlign="left"
            required
            validateStatus={errors.country ? "error" : "success"}
            help={errors?.country?.message}
          >
            <Select {...field} style={{ width: "100%" }}>
              {getCountryOptions()}
            </Select>
          </Form.Item>
        )}
      />
      <Controller
        name="state"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="State"
            labelAlign="left"
            required
            validateStatus={errors.state ? "error" : "success"}
            help={errors?.state?.message}
          >
            <Select {...field} style={{ width: "100%" }}>
              {getStateOptions(selectedCountry)}
            </Select>
          </Form.Item>
        )}
      />
      <Controller
        name="city"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="City"
            labelAlign="left"
            required
            validateStatus={errors.city ? "error" : "success"}
            help={errors?.city?.message}
          >
            <Select {...field} style={{ width: "100%" }}>
              {getCityOptions(selectedState)}
            </Select>
          </Form.Item>
        )}
      />
      <Controller
        name="pincode"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="Pincode"
            required
            labelAlign="left"
            validateStatus={errors.pincode ? "error" : "success"}
            help={errors?.pincode?.message}
          >
            <Input {...field} />
          </Form.Item>
        )}
        />*/}
    </Form>
  );
};

export default AddAddressForm;
